import React from 'react';
import styles from './snsListItem.module.scss';
import { Menu } from '@travel/icons/ui';
import { getSNSIcons } from 'utils/snsIcons';
import type { UserProfileSns } from 'store/apiTypes';
import { trimUrlProtocolSubDomain } from 'pages/MyReviewEdit/helper';
const snsIconsList = getSNSIcons(24);

type Props = {
  snsItem: UserProfileSns;
};

const SNSListItem: React.FC<Props> = ({ snsItem }) => {
  return (
    <div className={styles.container}>
      <div className={styles.titleSection}>
        <div className={styles.iconTitle}>
          <span className={styles.icon} data-testId={`${snsItem.platform}-icon`}>
            {snsIconsList[snsItem.platform]}
          </span>
          <span className={styles.title} data-testId={`platform-name-${snsItem.platform}`}>
            {trimUrlProtocolSubDomain(snsItem.url, snsItem.platform)}
          </span>
        </div>
        <div className={styles.arrowSection} data-testId="menu-icon">
          <Menu />
        </div>
      </div>
    </div>
  );
};

export default SNSListItem;
